// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3VJVg","icon":"SortAdornment_icon__2fz0L","up":"SortAdornment_up__2zWwt","down":"SortAdornment_down__uzyGD","active":"SortAdornment_active__1NGkF"};